"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _AnalyticsView = _interopRequireDefault(require("../records/AnalyticsView"));

var _AnalyticsViewsActions = require("../actions/AnalyticsViewsActions");

var _PropertyFilter = _interopRequireDefault(require("../records/PropertyFilter"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  currentViews: [],
  recentlyDeletedViews: []
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _AnalyticsViewsActions.FetchViewsActionTypes.SUCCESS, function (state, action) {
  var views = (0, _immutable.List)(action.payload.data.map(function (view) {
    var reportPropertyFilters = view.get('reportPropertyFilters').map(function (propertyFilter) {
      return new _PropertyFilter.default(propertyFilter);
    });
    return new _AnalyticsView.default((0, _extends2.default)({}, view.toJS(), {
      reportPropertyFilters: reportPropertyFilters
    }));
  }));
  var currentViews = views.filter(function (view) {
    return !view.deletedAt;
  });
  var recentDeletedViews = views.filter(function (_ref) {
    var deletedAt = _ref.deletedAt;
    return deletedAt > 0;
  });
  return state.set('currentViews', currentViews).set('recentlyDeletedViews', recentDeletedViews);
}), (0, _defineProperty2.default)(_handleActions, _AnalyticsViewsActions.AddViewActionTypes.SUCCESS, function (state, action) {
  var newId = action.payload.data.id;
  return state.update('currentViews', function (views) {
    return views.push(action.payload.props.set('id', newId).set('createdAt', _I18n.default.moment().valueOf()));
  });
}), (0, _defineProperty2.default)(_handleActions, _AnalyticsViewsActions.UpdateViewActionTypes.SUCCESS, function (state, action) {
  var updatedView = action.payload.props;
  return state.update('currentViews', function (views) {
    return views.filterNot(function (_ref2) {
      var id = _ref2.id;
      return id === updatedView.id;
    }).push(updatedView);
  });
}), (0, _defineProperty2.default)(_handleActions, _AnalyticsViewsActions.DeleteViewActionTypes.SUCCESS, function (state, action) {
  var deletedView = action.payload.props.set('deletedAt', _I18n.default.moment().valueOf());
  return state.merge({
    currentViews: state.get('currentViews').filterNot(function (view) {
      return view.id === deletedView.id;
    }),
    recentlyDeletedViews: state.get('recentlyDeletedViews').push(deletedView)
  });
}), (0, _defineProperty2.default)(_handleActions, _AnalyticsViewsActions.RestoreViewActionTypes.SUCCESS, function (state, action) {
  var restoredView = action.payload.props.set('deletedAt', 0);
  return state.merge({
    recentlyDeletedViews: state.get('recentlyDeletedViews').filterNot(function (view) {
      return view.id === restoredView.id;
    }),
    currentViews: state.get('currentViews').push(restoredView)
  });
}), (0, _defineProperty2.default)(_handleActions, _AnalyticsViewsActions.PermanentlyDeleteViewActionTypes.SUCCESS, function (state, action) {
  var deletedId = action.payload.props.id;
  return state.merge({
    recentlyDeletedViews: state.get('recentlyDeletedViews').filterNot(function (view) {
      return view.id === deletedId;
    })
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;